import { render } from "./AdminDashboard.vue?vue&type=template&id=3ad1023a&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=3ad1023a&scoped=true&lang=css"
import "./AdminDashboard.vue?vue&type=style&index=1&id=3ad1023a&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad1023a"]])

export default __exports__